import { Link } from "react-router-dom";
import { categories, featuredVideos, hotVideos, articles, siteInfo } from "@/mocks/data";
import VideoCard from "@/components/base/VideoCard";
import ArticleCard from "@/components/base/ArticleCard";

function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20warm%20orange%20and%20amber%20spotlight%20beams%20cutting%20through%20darkness%2C%20abstract%20film%20reel%20and%20projector%20light%20texture%2C%20luxurious%20velvet%20curtain%20aesthetic%2C%20premium%20cinema%20vibe%2C%20rich%20warm%20tones&width=1800&height=900&seq=hero-bg-jiujiu&orientation=landscape"
        alt="久久视频 - 高清影视平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            蓝光画质 <span className="text-primary-400">超清播放</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-2 max-w-2xl mx-auto">
            {siteInfo.description}
          </p>
          <p className="text-sm text-background-50/60 mb-8 max-w-xl mx-auto">
            聚合西瓜视频 · 樱花视频 · 糖豆视频等主流平台高清片源，最新上映院线电影免费在线观看
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/category/movie"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即观影
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function CategoryNav() {
  return (
    <section className="py-8 md:py-10 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 md:gap-4 overflow-x-auto pb-2 scrollbar-hide flex-wrap justify-center">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-100 hover:bg-primary-100 text-foreground-700 hover:text-primary-700 transition-all cursor-pointer whitespace-nowrap"
            >
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedSection() {
  return (
    <section className="py-8 md:py-10 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
              最新上映
            </h2>
            <p className="text-sm text-foreground-500 mt-1">院线大片蓝光画质，第一时间在线观看</p>
          </div>
          <Link
            to="/category/movie"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}

function HotSection() {
  return (
    <section className="py-8 md:py-10 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网热播影视综艺，大家都在看</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}

function PlatformFeatures() {
  const features = [
    {
      icon: "ri-4k-line",
      title: "蓝光画质",
      desc: "支持4K超高清播放，享受影院级观影体验",
    },
    {
      icon: "ri-flashlight-line",
      title: "极速加载",
      desc: "CDN全球加速，秒开无缓冲，流畅观影",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端同步",
      desc: "手机、平板、电脑无缝切换，随时随地看",
    },
    {
      icon: "ri-shield-check-line",
      title: "免费观看",
      desc: "全站内容免费不收费，无广告干扰",
    },
    {
      icon: "ri-stack-line",
      title: "海量片源",
      desc: "聚合多平台资源，电影电视剧综艺全覆盖",
    },
    {
      icon: "ri-translate-2",
      title: "中文字幕",
      desc: "外片自带中文字幕，追剧无障碍",
    },
  ];

  return (
    <section className="py-12 md:py-14 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            为什么选择久久视频
          </h2>
          <p className="text-sm text-foreground-500 mt-2">六大核心优势，打造极致观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-all">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">{f.title}</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticlesSection() {
  return (
    <section className="py-12 md:py-14 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
              影视资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新影视动态与观影指南</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {articles.slice(0, 4).map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20room%20with%20large%20screen%20displaying%20colorful%20movie%20scene%2C%20comfortable%20sofa%2C%20dim%20ambient%20lighting%2C%20popcorn%20on%20table%2C%20cinematic%20lifestyle%20photography%2C%20rich%20warm%20golden%20tones&width=1800&height=600&seq=cta-bg-jiujiu&orientation=landscape"
        alt="家庭影院体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative z-10 max-w-[800px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          即刻开启蓝光观影之旅
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8">
          久久视频聚合全网高清片源，免费不收费，随时随地畅享影院级观影体验
        </p>
        <Link
          to="/category/movie"
          className="inline-flex px-10 py-4 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          免费观影
        </Link>
      </div>
    </section>
  );
}

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <CategoryNav />
      <FeaturedSection />
      <HotSection />
      <PlatformFeatures />
      <ArticlesSection />
      <CTASection />
    </main>
  );
}